import { render } from "./GesMiscel.vue?vue&type=template&id=57986b07&scoped=true"
import script from "./GesMiscel.vue?vue&type=script&lang=js"
export * from "./GesMiscel.vue?vue&type=script&lang=js"

import "./GesMiscel.vue?vue&type=style&index=0&id=57986b07&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-57986b07"

export default script